import React, { useEffect, useState } from 'react';
import { MachineData } from '../../types/types';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
interface ProductionMetricsChartProps {
  machineData: MachineData[];
  timeRange: 'day' | 'week' | 'month' | 'custom';
  dateRange: {
    startDate: Date;
    endDate: Date;
  };
}
export const ProductionMetricsChart: React.FC<ProductionMetricsChartProps> = ({
  machineData,
  timeRange,
  dateRange
}) => {
  const [chartData, setChartData] = useState<any[]>([]);
  useEffect(() => {
    // Generiere Daten basierend auf dem ausgewählten Zeitraum
    const generateData = () => {
      const data = [];
      const timeRangeFactor = timeRange === 'day' ? 0.8 : timeRange === 'week' ? 1.0 : timeRange === 'month' ? 1.2 : 1.1; // custom
      // Bestimme Anzahl der Datenpunkte basierend auf Zeitraum
      const points = timeRange === 'day' ? 24 : timeRange === 'week' ? 7 : timeRange === 'month' ? 30 : Math.ceil((dateRange.endDate.getTime() - dateRange.startDate.getTime()) / (1000 * 3600 * 24));
      // Berechne Durchschnittswerte für alle Maschinen
      const avgEfficiency = Math.round(machineData.reduce((sum, machine) => sum + machine.metrics.efficiency, 0) / machineData.length);
      const avgLoad = Math.round(machineData.reduce((sum, machine) => sum + machine.metrics.currentLoad, 0) / machineData.length);
      const avgErrorRate = Math.round(machineData.reduce((sum, machine) => sum + machine.analytics.errorRate, 0) / machineData.length * 10) / 10;
      // Generiere Datenpunkte mit leichten Variationen
      for (let i = 0; i < points; i++) {
        const variationFactor = 0.85 + Math.random() * 0.3; // Zufällige Variation zwischen 0.85 und 1.15
        let label = '';
        if (timeRange === 'day') {
          label = `${i}:00`;
        } else if (timeRange === 'week') {
          const days = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
          label = days[i % 7];
        } else {
          label = `Tag ${i + 1}`;
        }
        data.push({
          name: label,
          efficiency: Math.min(Math.round(avgEfficiency * timeRangeFactor * variationFactor), 100),
          auslastung: Math.min(Math.round(avgLoad * variationFactor), 100),
          fehlerrate: Math.max(Math.min(Math.round(avgErrorRate * variationFactor * 10) / 10, 10), 0.1)
        });
      }
      return data;
    };
    setChartData(generateData());
  }, [machineData, timeRange, dateRange]);
  return <ResponsiveContainer width="100%" height="100%" data-id="element-63">
      <LineChart data={chartData} margin={{
      top: 5,
      right: 30,
      left: 20,
      bottom: 5
    }} data-id="element-64">
        <CartesianGrid strokeDasharray="3 3" stroke="#374151" data-id="element-65" />
        <XAxis dataKey="name" stroke="#9CA3AF" tick={{
        fill: '#9CA3AF'
      }} data-id="element-66" />
        <YAxis stroke="#9CA3AF" tick={{
        fill: '#9CA3AF'
      }} domain={[0, 100]} data-id="element-67" />
        <Tooltip contentStyle={{
        backgroundColor: '#1F2937',
        borderColor: '#374151',
        color: '#F9FAFB'
      }} data-id="element-68" />
        <Legend wrapperStyle={{
        color: '#E5E7EB'
      }} data-id="element-69" />
        <Line type="monotone" dataKey="efficiency" name="Effizienz (%)" stroke="#3B82F6" activeDot={{
        r: 8
      }} data-id="element-70" />
        <Line type="monotone" dataKey="auslastung" name="Auslastung (%)" stroke="#10B981" data-id="element-71" />
        <Line type="monotone" dataKey="fehlerrate" name="Fehlerrate (%)" stroke="#EF4444" data-id="element-72" />
      </LineChart>
    </ResponsiveContainer>;
};